/*通用工具库*/

import cookie from "js-cookie"
import api_dictionaries_data from "./api_dictionaries_data"
import Vue from 'vue'

Vue.filter('formatNull', function (val) {
  return val?val:'--'
})

const fxp = require("fast-xml-parser");
//日期格式化方法
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? o[k]
          : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

//日期格式化方法
let get_date_format = (isSubstitute = true, isDate = true, isTime = true, dateSign = '-', timeSign = ':') => {
  let dateStr = new Date()
  let year = dateStr.getFullYear();
  let month = dateStr.getMonth() + 1;
  let day = dateStr.getDate();
  let hour = dateStr.getHours();
  let minutes = dateStr.getMinutes();
  let seconds = dateStr.getSeconds();
  let returnDate = ''
  if (isSubstitute) {
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (seconds < 10) {
      seconds = '0' + seconds
    }
  }
  if (isDate && isTime) {
    returnDate = `${year}${dateSign}${month}${dateSign}${day} ${hour}${timeSign}${minutes}${timeSign}${seconds}`;
  } else {
    if (isDate) {
      returnDate = `${year}${dateSign}${month}${dateSign}${day}`;
    }
    if (isTime) {
      returnDate = `${hour}${timeSign}${minutes}${timeSign}${seconds}`;
    }
  }
  return returnDate
}

let downloadUrl = (url,filename)=>{
  let link = document.createElement('a')
  link.style.display ='none'
  link.download =  filename;
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}


/*获取vue实例*/
let get_main_vue = () => {
  return window.vue
}

/*统一的console.log入口*/
let sys_log = (val) => {
  if (!sys_log_abel) {
    return
  }
  console.log(val)
}

/*打印问题原因*/
let sys_reason_log = (val) => {
  if (!sys_cause_log) {
    return
  }
  console.log(val)
}


/*获取时间戳，参数格式 ‘20200101’*/
let get_timestamp = (date_str) => {
  let date_formatter = date_str.substr(0, 4) + "-" + date_str.substr(4, 2) + "-" + date_str.substr(6, 2)
  return new Date(date_formatter).getTime();
}

let timetoDate = (timestamp, type = "time") =>{
  if (!timestamp) {
    return "--";
  }
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  var time = "";
  if (type == "time") {
    time =
      year +
      "-" +
      (String(month).length > 1 ? month : "0" + month) +
      "-" +
      (String(day).length > 1 ? day : "0" + day) +
      " " +
      (String(hour).length > 1 ? hour : "0" + hour) +
      ":" +
      (String(minute).length > 1 ? minute : "0" + minute) +
      ":" +
      (String(second).length > 1 ? second : "0" + second);
  } else if (type == "date") {
    time =
      year +
      "-" +
      (String(month).length > 1 ? month : "0" + month) +
      "-" +
      (String(day).length > 1 ? day : "0" + day);
  }
  return time;
}


/*将数值依据id,pid生成树结构*/
/**
 * @param data_arr 数组
 * @param id  id属性名称
 * @param parentId   parentId属性名称
 * @param top_val   顶级的属性值
 * @param label 给改label赋值的属性名称
 * @param value 给改value赋值的属性名称
 * @returns {Array}
 */
let generate_tree_data = (data_arr, {id = 'id', parentId = "parentId", top_val = -1, label = 'name', value = "id"}) => {//生成Cascader级联数据
  var result = [];
  for (let item of data_arr) {
    if (item[parentId] == top_val) {//判断是否为顶层节点
      let temp_item = {'label': item[label], 'value': item[value]}//转换成el-Cascader可以识别的数据结构
      Object.assign(temp_item, item)
      temp_item.children = getchilds(item[id], data_arr, {id, parentId, top_val, label, value});//获取子节点
      result.push(temp_item);
    }
  }
  return result;
}

let getchilds = (cur_id, array, {id, parentId, top_val, label, value}) => {
  console.log(cur_id, array, id, parentId, top_val, label, value)
  let childs = new Array();
  for (let arr of array) {//循环获取子节点
    if (arr[parentId] == cur_id) {
      let temp_item = {'label': arr[label], 'value': arr[value]}
      Object.assign(temp_item, arr)
      childs.push(temp_item);
    }
  }
  for (let child of childs) {//获取子节点的子节点
    let childscopy = getchilds(child[id], array, {id, parentId, top_val, label, value});//递归获取子节点
    if (childscopy.length > 0) {
      child.children = childscopy;
    }
  }
  return childs;
}

/**
 * 成功提示
 * @param content 提示的内容
 * @param duration  提示持续时间
 */
let success = (content, duration = 5000, showclose = true) => {
  get_main_vue().$message.success({
    showClose: showclose,
    message: content,
    duration: duration
  });
}

/**
 * 错误提示
 * @param content 提示的内容
 * @param duration  提示持续时间
 */
let error = (content, duration = 2000, showclose = true) => {
  get_main_vue().$message.error({
    showClose: showclose,
    message: content,
    duration: duration
  });
}

/**
 * 警告提示
 * @param content 提示的内容
 * @param duration  提示持续时间
 */
let warning = (content, duration = 5000, showclose = true) => {
  get_main_vue().$message.warning({
    showClose: showclose,
    message: content,
    duration: duration
  });
}

// 生成uuid任务号
let get_task_id = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
}

/*设置cookie*/
let set_cookie = (key, value, option = {}) => {
  cookie.set(sys_token_prefix + key, value, option);
}

/*获取cookie*/
let get_cookie = (key) => {
  let res = cookie.get(sys_token_prefix + key);
  return res
}

/*移除cookie*/
let remove_cookie = (key) => {
  cookie.remove(sys_token_prefix + key)
}

/*保存当前用户信息*/
let save_user_info = (data) => {
  set_cookie("token", data.token, {expires: 0.5});
  set_cookie("zt_token", data.zt_token, {expires: 0.5});

  localStorage.setItem(sys_token_prefix + "user_info", JSON.stringify(data));
  localStorage.setItem(sys_token_prefix + "user_menu", JSON.stringify(data.auth_list));
}

/*获取当前用户信息*/
let get_user_info = () => {
  //return  sessionStorage.getItem(sys_token_prefix + "user_info");
  let user_info = localStorage.getItem(sys_token_prefix + "user_info")
  return user_info ? JSON.parse(user_info) : "";
}

/*删除用户登录信息*/
let del_user_info = () => {
  remove_cookie("token")
  //sessionStorage.removeItem(sys_token_prefix + "user_info");
  localStorage.removeItem(sys_token_prefix + "user_info");
}

/*获取token*/
let get_token = () => {
  return get_cookie("token");
}

/**
 * 前端分页逻辑
 * @param source_data 数据源
 * @param cur_page 要查询第几页的数据
 * @param page_size 每页多少个数据
 */
let get_data_by_page = (source_data, cur_page, page_size) => {
  let res = [];
  let from_index = (cur_page - 1) * page_size
  let to_index = cur_page * page_size
  res = source_data.slice(from_index, to_index)
  return res
}

/*获取副本*/
let get_copy = (row) => {
  if (!row) {
    return ""
  }
  return JSON.parse(JSON.stringify(row))
}

/*/!*根据key获取对应字典的文字*!/
let get_name_by_key = (row,key,dic_code) => {
  if(!row[key]){
    return
  }

  api_dictionaries_data.get_dictionaries(dic_code).then(res =>{
    let item = res.data.find(item => {return item.fCode == row[key]})
    if(item){
      row[key+ '_name'] = item.fName || '无'
    }
  })

}*/

/*添加字典表镜像字段，用于字典key显示为汉字用*/
let add_dic_image_field = (list = [], field) => {

  let field_arr = []
  if (!field instanceof Array) {
    field_arr = [field]
  } else {
    field_arr = field
  }

  list.forEach(item => {
    field_arr.forEach(item_inner => {
      item[item_inner + '_name'] = "";
    })
  })

  /*list.forEach(item =>{
    item[field + '_name'] = ''
  })*/
}


/**
 * 添加table可编辑单元格的镜像字段，用于处理单元格可编辑项的显隐
 * @param list 源数据列表
 * @param edat_able_fields 需要添加镜像的字段
 */
let add_edit_image_field = (list = [], edat_able_fields = []) => {
  list.forEach(item => {
    edat_able_fields.forEach(item_inner => {
      item[item_inner + '_edit_ing'] = false;
      item[item_inner + '_newval'] = item[item_inner];
    })
  })
}

/*根据rgb返回数组*/
let get_value_arr_from_rgb = (rgb) => {
  let arr = rgb.slice(rgb.indexOf("(") + 1, rgb.indexOf(")")).split(",")

  let res = []
  arr.forEach(item => {
    res.push(parseFloat(item))
  });
  return res
}


//从xml中获取节点内容

let getXmlNode = (xml_str) => {

//创建文档对象
  let parser = new DOMParser();
  let xmlDoc = parser.parseFromString(xml_str, "text/xml");

//提取数据
  let countrys = xmlDoc.getElementsByTagName('DataSource');

  let arr = [];

  for (var i = 0; i < countrys.length; i++) {
    arr.push(countrys[i].textContent);
  }
  ;

  return arr;

}

/*解析xml*/
let get_json_form_xml_ = (xml_str) => {
  var s = getXmlNode(xml_str);

//转成json格式
  var obj = eval('(' + s + ')');

//输出json
  return obj;
}


let get_json_form_xml = (content) => {
  return fxp.parse(content)
}

/**
 * 将数字转换为带千分符
 * @param num 需要转换千分符的数字
 * @returns {string}
 */
let formatNumberRgx = (num) => {
  let parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

/*注册功能*/
let register = (func_id, func) => {
  window.vue.register_center.registerFunc(func_id, func)
}

/*获取功能*/
let get_register = (func_id) => {
  let res = window.vue.register_center.getFuncById(func_id).funcObj
  return res
}

/*获取当前功能*/
let get_current_func = () => {
  let res = window.vue.register_center.getCurFuncObj()
  return res
}

/*激活功能*/
let active_func = (func_id, option) => {
  window.vue.register_center.activeFunc(func_id, option)
}

/*卸载功能*/
let inActive_func = (func_id, option) => {
  window.vue.register_center.inActive_module_by_id(func_id)
}

/*注册功能*/
let register_3D = (func_id, func) => {
  window.vue.register_center_3D.registerFunc(func_id, func)
}

/*获取功能*/
let get_register_3D = (func_id) => {
  let res = window.vue.register_center_3D.getFuncById(func_id).funcObj
  return res
}

/*激活功能*/
let active_func_3D = (func_id, option) => {
  window.vue.register_center_3D.activeFunc(func_id, option)
}

/**
 *单位转换函数
 * numValue数字
 * digit小数点后保留位数
 * unit基础单位
 * sswr是否四舍五入
 * return{num处理后数字，unit处理后单位}
 * */
let get_num_unit_format = (numValue, digit, unit,sswr = false) => {
  let num = Number(numValue).toString();
  let ab_num;
  if (num.indexOf('.') == -1) {
    ab_num =num
  } else{
    ab_num =num.substring(0,num.indexOf('.'))
  }

  let obj = {}
  if (num || Number(num) == 0) {
    if (Number(num) == 0) {
      obj = {num: 0, unit: unit}
    }else{
      if (ab_num.length < 5) {
        if (sswr){
          obj = {num: Number(Number(num).toFixed(digit)), unit: unit}
        } else {
          if (num.indexOf('.') == -1){
            obj = {num:Number(ab_num),unit: unit}
          } else{
            let xsdhNum = num.substr(num.indexOf('.')+1,digit);
            obj = {num:Number(ab_num+'.'+xsdhNum),unit: unit}
          }

        }

      } else if (ab_num.length >= 5 && ab_num.length < 9) {
        if (sswr) {
          obj = {num: Number((Number(num) / 10000).toFixed(digit)), unit: '万' + unit}
        }else{
          let realNum = Number(num) / 10000+'';
          let xsdqNum = realNum.substring(0,realNum.indexOf('.'));
          let xsdhNum = realNum.substr(realNum.indexOf('.')+1,digit);
          obj = {num:Number(xsdqNum+'.'+xsdhNum),unit: '万' + unit}
        }

      } else if (ab_num.length >= 9) {
        if (sswr) {
          obj = {num: Number((Number(num) / 100000000).toFixed(digit)), unit: '亿' + unit}
        }else {
          let realNum = Number(num) / 100000000+'';
          let xsdqNum = realNum.substring(0,realNum.indexOf('.'));
          let xsdhNum = realNum.substr(realNum.indexOf('.')+1,digit);
          obj = {num:Number(xsdqNum+'.'+xsdhNum),unit: '亿' + unit}
        }

      }
    }
  }

  return obj
};

let get_mapboxgl = () => {
  let mapboxgl = window.mapbox3857
  if (sys_epsg == '4490') {
    mapboxgl = window.mapbox4490
  }
  return mapboxgl
}

/*获取年份字典名称*/
let get_nf_dic_name = () => {
  /*当前专题名称*/
  let cur_zt_name = window.vue.$store.getters["sys_common_store/get_sys_func_name"]

  let dic_name = ''
  if (cur_zt_name) {
    dic_name = sys_nf_config[cur_zt_name]
    if (!dic_name) {
      sys_log(cur_zt_name + '专题未配置年份字典属性，默认使用非专题年份')
      dic_name = dic_name = sys_nf_config['默认年份']
    }
  } else {
    dic_name = sys_nf_config['默认年份']
  }

  return dic_name
}

/*根据某属性对数组排序*/
let sort_by_prop = (arr, prop_name, order = 1) => {
  function compare(property) {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      if (order === 1) {
        return value1 - value2;
      } else {
        return value2 - value1;
      }
    }
  }

  arr.sort(compare(prop_name))
}

/*获取当前浏览模式*/
let get_cur_view_mode = () => {
  return window.vue.$store.getters["sys_common_store/get_cur_view_mode"];/*浏览模式*/
}

/*获取当前年份*/
let get_cur_nf = () => {
  return window.vue.$store.getters["sys_common_store/get_sys_nf"];
}

/*获取当前专题*/
let get_cur_theme = () => {
  return window.vue.$store.getters["sys_common_store/get_sys_theme"];
}

/*获取所有图层属性信息*/
let get_all_layer_info = () => {
  return window.vue.$store.getters["sys_common_store/get_sys_layer_info"];
}

/*获取所有多合一图层属性信息*/
let get_multi_layer_info = () => {
  return window.vue.$store.getters["sys_common_store/get_sys_multi_layer_info"];
}

/**
 * 将图层信息数组过滤，过滤出符合当前年份，专题，浏览模式的结果并返回
 * @param layer_info 节点数组
 * @param consider_props 过滤的时候考虑的条件 nf:年份； theme:专题 ; mode:模式； default:模式是否显示
 * @param filter_params 过滤的时候考虑的附加参数
 * @returns {[[], []]}
 */
let filter_layer_info = (layer_info, consider_props = ['nf', 'theme', 'mode', 'default'], filter_params = {}) => {

  /*
  * 过滤逻辑：
  *模式变了： 考虑年份，模式，专题  考虑默认显示，
  *年份变了： 考虑年份，模式，专题  考虑默认显示，
  *专题变了： 考虑年份，模式，专题  考虑默认显示，
  *手动勾选中：考虑模式 不考虑默认显示， 年份和专题也不考虑
  *手动勾选掉：全部隐藏
  * */


  /*最终要显示的图层id*/
  let finale_layer_ids = []
  let finale_layer_node = []

  let cur_nf = filter_params.nf || window.GLOBAL.common_tool.get_cur_nf();
  let cur_view_mode = window.GLOBAL.common_tool.get_cur_view_mode();
  let cur_theme = filter_params.theme || window.GLOBAL.common_tool.get_cur_theme();

  /*
  * 浏览模式
  * 1. 矢量+矢栅 4
  * 2. 矢量  1
  * 3. 矢栅 2
  * 4. 影像 3
  * 5. 全部 5
  * */

  /*过滤的时候，配置了什么属性就考虑什么属性，如果没有配置该属性就不考虑，如果什么属性都没有，显示不显示* */

  layer_info.forEach(item => {

    /*是否允许通过*/
    let allow_ = true

    /*考虑默认的情况*/
    if (consider_props.includes('default')) {
      /*浏览模式是5（全部的时候可以考虑默认显示，其他浏览模式不管consider_props中是否考虑默认，都不会进行考虑，需要到模式中自动处理）*/
      if(item.default_show){
        allow_ = true
      }else{
        allow_ = false

        /*改了，上面说的默认显示的只在浏览模式是全部的时候考虑，改了，只要默认设置为不显示，
        * 那就不显示，这里直接return
        * */
        return
      }
    }

    /*这里不对allow_进行判断处理，因为后续的浏览模式可能会对allow_进行修改*/

    /*考虑浏览模式的情况(双条件，后面的jcdlxx意思是基础地理信息数据不需要考虑模式，不管consider_props里是否要求了要考虑浏览模式)*/
    if (consider_props.includes('mode') && item.theme_code != 'jcdlxx') {
      /*如果是全部*/
      if (item.view_mode_code == 5) {
        /*这里不处理，5表示‘全部’浏览模式，这里不做干预处理*/

      } else if (item.view_mode_code == 4) {
        /*如果矢量+矢栅*/
        if (cur_view_mode == 1 || cur_view_mode == 2) {
          allow_ = true
        } else {
          allow_ = false
        }
      } else {
        /*如果是矢量、矢栅、影像*/
        if(cur_view_mode == item.view_mode_code){
          allow_ = true
        }else{
          allow_ = false
        }
      }
    }

    /*不符合条件不再继续*/
    if(!allow_){return }


    /*考虑年份是否符合要求*/
    if (consider_props.includes('nf')) {
      if(cur_nf && item.nf && cur_nf == item.nf){
        allow_ = true
      }else{
        allow_ = false
      }
    }

    /*不符合条件不再继续*/
    if(!allow_){return }

    /*考虑专题是否符合要求,基础地理数据专题的数据不进行判断*/
    if (consider_props.includes('theme')  && item.theme_code != 'jcdlxx' ) {
      if(cur_theme && item.theme_code && cur_theme == item.theme_code){
        allow_ = true
      }else{
        allow_ = false
      }
    }

    /*不符合条件不再继续*/
    if(!allow_){return }

    finale_layer_ids.push(item.layer_name)
    finale_layer_node.push(item)
  })

  return [
    finale_layer_ids,
    finale_layer_node
  ]
}


/*同步首页主图*/
let synchronization_main_map = () => {
  let map_ojbs = []
  if (map_ojbs.length == 0) {
    return
  }
  /*这里先获取首页地图style，然后对各个需要同步主地图的地图实例进行遍历，控制图层显隐与首页地图一致*/

  let main_map = window.GLOBAL.common_store.sys_map
  let style = main_map.getStyle()

  let layers_should_show = []
  let layers_should_hide = []

  style.layers.forEach(item => {
    if (item.layout && item.layout.visibility == 'none') {
      layers_should_hide.push(item.id)
    } else {
      layers_should_show.push(item.id)
    }
  })

  map_ojbs.forEach(map_item => {
    window.GLOBAL.map_tool.show_layer(layers_should_show, {map: map_item})
    window.GLOBAL.map_tool.hide_layer(layers_should_hide, {map: map_item})
  })
}

/*获取当前所有二维地图实例*/
let get_all_map_instance = (options = {}) => {
  let is_cur_multi_scr = window.vue.$store.getters["sys_common_store/get_cur_multi_scr_name"]
  let map_instance = []
  /*卷帘*/
  if (is_cur_multi_scr == "水平卷帘" || is_cur_multi_scr == "垂直卷帘") {
    map_instance.push(window.GLOBAL.common_store.sys_map_right)
  }

  /*分屏*/
  let multi_scr_num = 0
  if (is_cur_multi_scr == "三分屏") {
    multi_scr_num = 3
  }
  if (is_cur_multi_scr == "水平分屏") {
    multi_scr_num = 2
  }
  if (is_cur_multi_scr == "垂直分屏") {
    multi_scr_num = 2
  }
  if (is_cur_multi_scr == "水平三分屏") {
    multi_scr_num = 3
  }
  if (is_cur_multi_scr == "四分屏") {
    multi_scr_num = 4
  }

  if (multi_scr_num) {
    for (let i = 1; i <= multi_scr_num; i++) {
      map_instance.push(window.GLOBAL.common_store["_2d_three_s_num" + i])
    }
  }

  /*是否保护主页地图*/
  if (options.contain_main_map) {
    map_instance.push(window.GLOBAL.common_store.sys_map)
  }

  return map_instance

}

/*是否需要控制这个图层*/
let is_unctrl = (layer_id) => {
  if (!layer_id) {
    return false
  }
  let res = true

  for (let i = 0; i < un_ctrl_layer_prefix.length; i++) {
    if (layer_id.startsWith(un_ctrl_layer_prefix[i])) {
      res = false
      break
    }
  }

  return res
}

let get_num_by_array = (str) =>{
  return (str + '').split('')
}

let qxkz_btn = (yjmc, ejmc, qxmc, sjmc) => {
  let flag = false;
  let menu = localStorage.getItem(sys_token_prefix + "user_menu");
  menu = menu == 'undefined'?'[]':menu;
  let user_menu = JSON.parse(menu);
  for (let i = 0; i < user_menu.length; i++) {
    if (user_menu[i].name == yjmc && user_menu[i].children) {
      let secondChild = user_menu[i].children
      for (let j = 0; j < secondChild.length; j++) {
        if (secondChild[j].name == ejmc && secondChild[j].children) {
          let thirdChild = secondChild[j].children
          for (let s = 0; s < thirdChild.length; s++) {
            let fourthChild = thirdChild[s].children ? thirdChild[s].children : []
            if (thirdChild[s].name == sjmc && fourthChild.length > 0) {
              for (let m = 0; m < fourthChild.length; m++) {
                if (fourthChild[m].data.url == qxmc) {
                  flag = true
                  break
                }
              }
            }
            if (thirdChild[s].data.url == qxmc) {
              flag = true
              break
            }
          }
        }

        /*处理只有一级菜单的情况*/
        if( ejmc == '无' && secondChild[j].data.url == qxmc ){
          flag = true
          break
        }
      }
    }
  }
  return flag
}

/*获取当前选中设备类型*/
let get_cur_selected_sb_type = (type = true) => {
  let map = window.GLOBAL.common_store.sys_map

  /*传感器类型(1-视频2-轨迹3-气象4-土壤5-空气6-虫情7-水体)*/
  let sb_layer_ids = [
    {id:'视频监控设备',type:"1"},
    {id:'轨迹监控设备',type:"2"},
    {id:'气象环境监测设备',type:"3"},
    {id:'土壤环境监测设备',type:"4"},
    {id:'空气质量监测设备',type:"5"},
    {id:'虫情监测设备',type:"6"},
    {id:'水体环境监测设备',type:"7"},
  ]

  let res = []
  sb_layer_ids.forEach(item => {
    if(map.getLayoutProperty(item.id,'visibility') != 'none'){
      if(type){
        res.push(item.type)
      }else{
        res.push(item.id)
      }

    }
  })

  return res
}

export default {
  sys_log,/*统一的console.log入口*/
  sys_reason_log,/*打印问题原因*/
  get_timestamp,/*获取时间戳，参数格式 ‘20200101’*/
  timetoDate,
  generate_tree_data,/*将数值依据id,pid生成树结构*/

  success,/*vue成功提示*/
  error,/*vue错误提示*/
  warning,/*vue警告提示*/

  get_task_id,/*生成uuid*/
  save_user_info,/*获取用户信息*/
  get_user_info,/*获取用户信息*/
  del_user_info,/*删除用户信息*/
  get_token,/*删除用户信息*/

  set_cookie,/*设置cookie*/
  get_cookie,/*获取cookie*/
  remove_cookie,/*移除cookie*/

  get_data_by_page,/*前端分页逻辑*/
  get_copy,/*获取副本*/

  add_dic_image_field,/*添加字典镜像字段，用于table列表中转译字典码为汉字*/
  add_edit_image_field,/*添加镜像字段，用于table中编辑单元格的时候控制 输入框、下拉框的显隐*/

  get_date_format,/*日期格式化*/
  get_value_arr_from_rgb,/*根据rgb返回数组*/

  get_json_form_xml,/*解析xml*/
  formatNumberRgx,/*将数字转换为带千分符*/

  register,/*注册功能*/
  get_register,/*获取功能*/
  get_current_func,/*获取当前功能*/
  active_func,/*激活功能*/
  inActive_func,/*卸载功能*/

  register_3D,/*注册功能*/
  get_register_3D,/*获取功能*/
  active_func_3D,/*激活功能*/

  get_num_unit_format,/*单位转换函数*/

  get_mapboxgl,/*获取mapboxgl实例*/

  get_nf_dic_name,/*获取年份字典名称*/

  sort_by_prop,/*根据某属性对数组排序*/

  get_cur_view_mode,/*获取当前浏览模式*/
  get_cur_nf,/*获取当前年份*/
  get_cur_theme,/*获取当前专题*/
  get_all_layer_info,/*获取所有图层属性信息*/
  get_multi_layer_info,/*获取所有多合一图层属性信息*/
  filter_layer_info,/*将图层信息数组过滤，过滤出符合当前年份，专题，浏览模式的结果并返回*/

  synchronization_main_map,/*同步首页主图*/
  get_all_map_instance,/*获取当前所有二维地图实例*/

  is_unctrl,/*图层是否不需要控制*/
  downloadUrl,  /* 下载url */

  get_num_by_array,/*数字或字符串转换成单个数字数字*/
  qxkz_btn,   /*权限控制按钮菜单*/

  get_cur_selected_sb_type,/*获取当前选中设备类型*/
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/common_tool.js